/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementTabsViewModel } from "../types/CourseRegistrationManagementTabsViewModel.ts";

export const courseRegistrationManagementTabsViewModelSchema = z.object({
  details: z.optional(
    z
      .boolean()
      .describe("Indica se a aba Detalhes está disponível. Sempre verdadeiro."),
  ),
  history: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Histórico está disponível. Sempre verdadeiro.",
      ),
  ),
  instructions: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Instruções está disponível. Exibida apenas para usuários não polo.",
      ),
  ),
  audit: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Auditoria está disponível. Exibida apenas para usuários não polo.",
      ),
  ),
  monograph: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Monografia está disponível. Exibida apenas para usuários não polo quando o curso possui monografia habilitada.",
      ),
  ),
  courseAccess: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Acesso ao Curso está disponível. Exibida apenas para usuários não polo.",
      ),
  ),
  scholarship: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Detalhe de Bolsa está disponível. Exibida apenas para usuários não polo quando existem bolsas vinculadas.",
      ),
  ),
  studentIndicator: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Aluno Indica Aluno está disponível. Exibida apenas para usuários não polo.",
      ),
  ),
  selectiveProcess: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Processo Seletivo está disponível. Exibida apenas para usuários não polo quando existe processo seletivo.",
      ),
  ),
  poloHistory: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Histórico de Polo está disponível. Exibida apenas para usuários não polo.",
      ),
  ),
  financial: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aba Financeiro está disponível. Exibida apenas para usuários polo.",
      ),
  ),
}) as unknown as ToZod<CourseRegistrationManagementTabsViewModel>;
